// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__CdzXx","slider-content":"Carousel_slider-content__FeGb7","icon-container":"Carousel_icon-container__MBhfy","icon":"Carousel_icon__UV7Fu"};